import Cloud from './Cloud';

const SPACING_MIN = 18;
const SPACING_MAX = 36;
const TOTAL_FRAMES = 3;
const OFFSCREEN = 96;
const SPEED = 0.05;
const SCREEN_HEIGHT = 64;

export default class {
  constructor(config) {
    const count = config.count;
    this.scene = config.scene;
    this.clouds = [];
    this.addClouds(count, SCREEN_HEIGHT);
  }

  addClouds(count, y) {
    for (let i = 0; i < count; i++) {
      let cloud = new Cloud({
        scene: this.scene,
        x: i * Phaser.Math.RND.between(SPACING_MIN, SPACING_MAX),
        y: Phaser.Math.RND.between(y, y - SCREEN_HEIGHT),
        frame: Phaser.Math.RND.between(0, TOTAL_FRAMES)
      });
      this.clouds.push(cloud);
    }
  }

  update(d) {
    this.clouds.forEach(function (cloud) {
      if (cloud.x <= -SCREEN_HEIGHT / 2.0) {
        cloud.x = OFFSCREEN;
      }
      cloud.x -= SPEED;
    });
  }

  setTint() {}
}